import { render, staticRenderFns } from "./BrandDropdown.vue?vue&type=template&id=6bc1d889&"
import script from "./BrandDropdown.vue?vue&type=script&lang=js&"
export * from "./BrandDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc1d889')) {
      api.createRecord('6bc1d889', component.options)
    } else {
      api.reload('6bc1d889', component.options)
    }
    module.hot.accept("./BrandDropdown.vue?vue&type=template&id=6bc1d889&", function () {
      api.rerender('6bc1d889', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navbar/BrandDropdown.vue"
export default component.exports